<template>
  <div>
    <div class="banner"></div>
    <div class="hospital">
      <img class="cover"
           :src="baseURL + hospital.hospital_img"
           alt="">
      <div class="detail">
        <h3 v-html="setDoctorName(hospital.name)"></h3>
        <div class="labels">
          <label>优势：</label>
          <div class="label-list">
            <span v-for="(l,index) in department"
                  :key="index">{{l}}</span>
          </div>
        </div>
        <button v-if="hospital.hospital_type != 4" class="button-order"
                @click="orderNow(hospital.id)">立即预约</button>
      </div>
    </div>
    <div class="hos-body">
      <Breadcrumb class="bread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/internationalIndex">海外医疗</BreadcrumbItem>
        <BreadcrumbItem to="/hospitalList/fwlx/0">权威医院</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">{{hospital.name}}</BreadcrumbItem>
      </Breadcrumb>
      <!-- <Bread class="bread"/> -->
      <div class="hos-main">
        <div v-html="hospital.brief"></div>
        <Button type="primary"
                size="large"
                style="margin-top: 30px;"
                v-show="hospital.package_num>0"
                @click="taocan = true">查看医院套餐</Button>
      </div>
    </div>
    <!-- 对话框，显示套餐 -->
    <Modal v-model="taocan"
           title="医院套餐"
           width="1200px"
           @on-ok="okByTaocan">
      <div v-html="hospital.package"></div>
    </Modal>
  </div>
</template>
<script>
// import Bread from '@/components/Bread.vue'
import * as apis from '@/api/hospital'
import * as api from '@/api/login';
// import { getUserAgreementsRuls } from '@/api/other'
import { baseURL } from '@/api/axios'
import { getLocalStorage } from '@/utils/tools.js'
export default {
  data () {
    return {
      baseURL,
      taocan: false,
      id: 1,
      hospital: {
        hospital_img: ''
      },
      department: [],
    }
  },
  components: {

    // Bread,

  },
  mounted () {
    let id = this.$route.params.id;
    this.id = id;
    localStorage.setItem('hid', id);
    this.getHospitalInfo(id);
  },
  methods: {
    async getHospitalInfo (id) {
      try {
        let data = {
          id: id
        }
        let res = await apis.getOneHospitalInfo(data);
        if (res.code == 200) {
          this.hospital = res.data;
          this.department = res.data.department_name;
          localStorage.setItem('hospital_type', this.hospital.form_type);
        }
      } catch (e) {
        console.log(e)
      }
    },
    async orderNow (id) {
      let token = getLocalStorage('token');
      let res = await api.getUserInfoData({ token });
      if (res) {
        let type = localStorage.getItem('hospital_type');
        if (type.indexOf('1') > -1) {
          this.$router.push({ name: 'Form', params: { hid: this.id } });
        } else if (type.indexOf('2') > -1) {
          this.$router.push({ name: 'FormOfOne', params: { hid: this.id } });
        } else if (type.indexOf('3') > -1) {
          this.$router.push({ name: 'FormOfTwo', params: { hid: this.id } });
        } else if (type.indexOf('4') > -1) {
          this.$router.push({ name: 'FormOfThree', params: { hid: this.id } });
        }
      }
    },
    okByTaocan () {
      this.taocan = false;
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  height: 250px;
  background: url('../assets/images/hospital/banner.jpg') no-repeat center;
  background-size: 100% 250px;
}
.hospital {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 970px;
  min-height: 390px;
  background: #fff;
  border: 1px solid #dcdcdc;
  padding: 20px;
  margin: -182px auto 0;
  .cover {
    width: 460px;
    height: 338px;
    margin-right: 45px;
  }
  .detail {
    display: inline-flex;
    flex-direction: column;
    /*justify-content: space-between;*/
    width: 420px;
    // vertical-align: top;
    h3 {
      color: #333130;
      font-size: 25px;
      font-weight: normal;
      margin-top: 20px;
      margin-bottom: 18px;
    }
    .labels {
      label {
        font-size: 18px;
        color: #333130;
        line-height: 40px;
      }
      .label-list {
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 366px;
        span {
          display: inline-block;
          min-width: 116px;
          height: 40px;
          background: #f1f1f1;
          color: #333130;
          font-size: 16px;
          line-height: 40px;
          text-align: center;
          margin-right: 6px;
          margin-bottom: 20px;
          padding: 0 10px;
        }
      }
    }
  }
}
.hos-body {
  width: 970px;
  margin: 0 auto;
}
.bread {
  margin: 40px auto;
}
.hos-main {
  width: 970px;
  border: 1px solid #dcdcdc;
  background: #fff;
  overflow-x: auto;
  // padding: 40px 54px 68px;
  padding: 20px;
  margin-bottom: 50px;
  h4 {
    font-size: 30px;
    color: #ae1e10;
    font-weight: normal;
    margin-bottom: 38px;
    span {
      color: #898888;
      font-size: 18px;
    }
  }
  .hos-txt {
    color: #333130;
    font-size: 18px;
    line-height: 36px;
    text-indent: 36px;
    margin-bottom: 34px;
  }
  h5 {
    color: #333130;
    font-size: 30px;
    font-weight: normal;
    line-height: 34px;
    margin-bottom: 30px;
  }
  .open-time {
    width: 514px;
    height: 100px;
    margin-bottom: 80px;
    tr td {
      font-size: 14px;
      border: 1px solid #666;
      padding: 5px;
    }
  }
  .hos-addr {
    p {
      font-size: 22px;
      color: #333130;
      line-height: 36px;
      span {
        display: inline-block;
        width: 126px;
      }
    }
  }
}
.mb40 {
  margin-bottom: 40px;
}
.mb50 {
  margin-bottom: 50px;
}
</style>

